import { useEffect, useState } from "react";

function useRefreshTimer(intervalMinutes = 5) {
  const intervalMs = intervalMinutes * 60 * 1000;
  const [timeLeft, setTimeLeft] = useState(intervalMs);

  useEffect(() => {
    const startTime = Date.now();

    const timer = setInterval(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(intervalMs - elapsed, 0);
      setTimeLeft(remaining);
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, [intervalMinutes]);

  const percentage = 100 - Math.floor((timeLeft / intervalMs) * 100);

  return {
    timeLeft,
    percentage,
  };
}

export default useRefreshTimer;
